import styled from "styled-components";

export const StyledGroupedFields = styled.div`
    display: flex;
    flex-wrap: wrap;    
    position: relative;
`;